module.exports = __webpack_public_path__ + "img/pistol.prototype17.ff9c3b46.png";